module.exports = __webpack_public_path__ + "img/econet_mini_logo.04428497.svg";